const ECG_FROM_DB_STROKE = '#00008B';
const ECG_DOWNLOAD_STROKE = '#FF0000';
const ECG_GRID_PRINT_COLOR = '#FF0000';
const ECG_STROKE_PRINT_COLOR = '#000000';
const ECG_COMPARED_STROKE_PRINT_COLOR = '#0000FF';
const COMPARED_ECG_DURATION = 30;

export {
  ECG_DOWNLOAD_STROKE,
  ECG_FROM_DB_STROKE,
  ECG_GRID_PRINT_COLOR,
  ECG_STROKE_PRINT_COLOR,
  COMPARED_ECG_DURATION,
  ECG_COMPARED_STROKE_PRINT_COLOR,
};
